/**
 * 支持的图像类型
 * @see FXD-58554
 */
export const IMAGE_SUPPORT_TYPE = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];

/**
 * 文件上传数量
 */
export const UPLOAD_FILE_COUNT = {
    SINGLE: 1,
    MULTI: 10
};
